import { PropsWithChildren } from 'react';

import { FeatureHeader, GridContentWrapper, GridWrapper } from './index.styles';

interface FeatureGridContentProps {
  bgColor?: string;
  title: string;
}

const FeatureGridContent: React.FC<FeatureGridContentProps & PropsWithChildren> = ({
  bgColor,
  children,
  title,
}) => {
  return (
    <GridWrapper bgColor={bgColor}>
      <FeatureHeader type="secondary">{title}</FeatureHeader>
      <GridContentWrapper>{children}</GridContentWrapper>
    </GridWrapper>
  );
};

export default FeatureGridContent;
